import { Button, Text, Box } from '@/theme/index';
import { ModalBox, StyledModal } from './components';
import { valuationText } from './valuationText';

export type modalObject = {
  modalOpen: boolean;
  modalType: string;
};

interface ValuationModalProps {
  modal: modalObject;
  toggleModal: (modalType: string | null) => void;
}

export const ValuationModal = ({ modal, toggleModal }: ValuationModalProps) => {
  const valuationData = valuationText[modal.modalType] || {
    title: '',
    body: '',
  };
  const { title } = valuationData;
  const { body } = valuationData;

  const handleClick = () => {
    toggleModal(null);
  };

  return (
    <StyledModal
      open={modal.modalOpen}
      onClose={handleClick}
      aria-labelledby={title}
      aria-describedby={body}
    >
      <ModalBox>
        <Text variant="h3">{title}</Text>
        <Text>{body}</Text>
        <Box display="flex" justifyContent="center" marginTop={2}>
          <Button variant="contained" onClick={handleClick} color="success">
            Return to vehicle report
          </Button>
        </Box>
      </ModalBox>
    </StyledModal>
  );
};
